import { isNil } from 'lodash';
import { commaSeparatedUniq } from 'utils/commaSeparatedText';

export const survivingClaimNumberUniq = (
  commaSeparated: string | null | undefined,
) => {
  if (isNil(commaSeparated)) return commaSeparated ?? undefined;
  return commaSeparatedUniq(commaSeparated);
};
